import { render, staticRenderFns } from "./AddTaskMC.vue?vue&type=template&id=0bfe0542&scoped=true"
import script from "./AddTaskMC.vue?vue&type=script&lang=js"
export * from "./AddTaskMC.vue?vue&type=script&lang=js"
import style0 from "./AddTaskMC.vue?vue&type=style&index=0&id=0bfe0542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe0542",
  null
  
)

export default component.exports